export default str => str.replace(/\D/g, '');
